<section class="sku_page" #createSKUPage>
  <div class="d-flex flex-column h-100" id="createSkuIdInfo">
    <div class="create_new_sku_header" id="createNewSkuHeader">
      <div class="d-flex align-items-center" id="skuInfoDFlex">
        <img class="create_new_sku_icon" alt="Create New SKU icon" />
        <span i18n="@@create-sku-id-info.title.sku-info">SKU INFORMATION</span>
      </div>
    </div>
    <form [formGroup]='skuIdInfoForm' autocomplete="off">
      <div class="sku_body" id="skuInfoBody">
        <div class="sku_body_section1" id="skuInfoBodySection">
          <div class="d-flex" id="skuBodyDFlex">
            <div class="form-group" id="skuFrmGrp">
              <label for="skucode">{{skuCodeText}}</label>&nbsp;<span class="text-danger">*</span>
              <input id="skucode" formControlName="skuCode" maxlength="50" class="form-control"
                [ngClass]="{'has-error': isSKUCodeExists}" type="text" (input)="onInputClicked()"
                [placeholder]="skuCodeText" required />
              <span *ngIf="isSKUCodeExists" class="pt-1 text-danger sku-code-error-msg">{{errorMessage}}</span>
            </div>
            <div class="form-group" id="internalNameDiv">
              <label for="internalname">{{internalNameText}}</label>
              <input id="internalname" formControlName="internalName" maxlength="50" class="form-control" type="text"
                [placeholder]="internalNameText" />
            </div>
          </div>
          <div class="sku_detailed_sections" id="skuDetailedSections">
            <div class="sku_subtitles" i18n="@@create-sku-id-info.title.enter-battery-life" id="skuEnterBatteryLife">Enter Battery life</div>
            <div class="form-group mb-0" id="skuDetailedfrmGrp">
              <label for="batterylife">{{batteryLifeText}}</label>
              <div class="d-flex" id="batteryLife"><input id="batterylife" class="form-control" type="text"
                  formControlName="batteryLife" (keypress)="patternToAllowOnNumbers($event)"
                  [placeholder]="batteryLifePlaceholderText" /><span
                  i18n="@@create-sku-id-info.hours.label">Hours</span></div>
            </div>
            <span class="battery-life-note" i18n="@@create-sku-id-info.note.battery-life-greate-than-zero">Note: Battery
              life should be greater than zero</span>
          </div>
          <div class="pt-1 sku_detailed_sections2" *ngIf="!isPriceSupress" id="skuDetailedSec2">
            <div class="sku_subtitles" i18n="@@create-sku-id-info.title.enter-price" id="skuSubTitlePrice">Enter Price</div>
            <div class="d-flex" id="skuDFlex">
              <div class="form-row" id="skuFrmRow">
                <div class="form-group" id="frmGrpPrimaryPrice">
                  <label i18n="@@create-sku-id-info.label.enter-prmary-price">Primary Price</label>
                  <input type="text" class="form-control" formControlName="primaryPrice"
                    [placeholder]="primaryPricePlaceholderText" (input)="getPriceValue()">
                </div>
                <div class="form-group" id="devicePriceConColor">
                  <label i18n="@@device-price-content.title.color">Color</label>
                  <div id="colorPickerBtn">
                    <input class="color_picker_button default" name="primary-color" [(colorPicker)]="primaryColor"
                      (colorPickerChange)="changeColorPicker($event,'primary')"
                      [ngStyle]="{'background-color':primaryColor}" readonly />
                  </div>
                </div>
              </div>
              <div class="form-row" id="sku2PriceFrmRow">
                <div class="form-group" id="sku2PriceFrmGrp">
                  <label i18n="@@create-sku-id-info.label.enter-secondary-price">Secondary Price</label>
                  <input type="text" class="form-control" formControlName="secondaryPrice"
                    [placeholder]="secondaryPricePlaceholderText" (input)="getSecondaryPriceValue()">
                </div>
                <div class="form-group" id="devicePriceConTitle">
                  <label i18n="@@device-price-content.title.color">Color</label>
                  <div id="colorPickerBtnSecondary">
                    <input class="color_picker_button default" name="secondary-color" [(colorPicker)]="secondaryColor"
                      (colorPickerChange)="changeColorPicker($event,'secondary')"
                      [ngStyle]="{'background-color':secondaryColor}" readonly />
                  </div>
                </div>
              </div>
              <div class="form-row" id="priceStrike">
                <div class="form-check" id="frmCheckPriceStrike">
                  <input class="form-check-input" type="checkbox" id="pricestrike" value="pricestrike"
                    [disabled]="isPriceStrikethroughDisabled" [checked]="isPriceStrikethrough === 'T' ? true: false"
                    (change)="togglePriceStrikethrough($event)">
                  <label class="form-check-label" for="pricestrike"
                    i18n="@@create-sku-id-info.label.check-price-strikethrough">Price Strikethrough
                    ($900.00)</label>
                </div>
                <div class="form-group" id="priceBgColor">
                  <label i18n="@@device-price-content.title.price-background-color">Price Background color</label>
                  <div>
                    <input class="color_picker_button default" name="background-color"
                      [(colorPicker)]="priceBackgroundColor"
                      (colorPickerChange)="changeColorPicker($event,'backgroundColor')"
                      [ngStyle]="{'background-color':priceBackgroundColor}" readonly />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="d-flex select-detail-group" id="selectDetailGrp">
            <div class="sku_detailed_sections" id="skuDetailedSections">
              <div class="sku_subtitles" id="skuSubTitleSegment" i18n="@@sku-id-info.sku-subtitles.select-segment">Select Segment</div>
              <div class="form-group" id="segmentLblTxt">
                <label for="segment">{{segmentLabelText}}</label>

                <!-- SEGMENT Search and SELECT -->
                <div class="create_sku_id_dropdown" id="skuIdSegDropdown">
                  <ng-select placement="top" [items]="segmentList" [placeholder]="searchByNamePlaceholderText"
                    bindLabel="name" bindValue="id" name="segment-list-dropDown" [clearable]="true" [selectOnTab]="true"
                    (change)='getSelectedSegment($event)' [(ngModel)]="selectedSegmentId"
                    [ngModelOptions]="{standalone: true}">
                    <ng-template ng-option-tmp let-item="item" let-index="index" class="ng_selection_template">
                      <div id="itemName">{{item.name}}</div>
                      <span i18n="@@create-sku-id-info.sku-id-dropdown.content-id">Content ID: {{item.id}}</span>
                    </ng-template>
                  </ng-select>
                  <div *ngIf='!selectedSegmentId' class="search-icon"></div>
                </div>

              </div>
            </div>
            <div class="sku_detailed_sections" *ngIf="isCustomTileEnabled" id="skuDetailedSec">
              <div class="sku_subtitles" i18n="@@create-sku-id-info.title.select-custom-main-tile"
                id="selectCustomMainTile">Select Custom Main Tile</div>
              <div class="form-group" id="customMainTile">
                <label for="custommaintile" i18n="@@create-sku-id-info.label.custom-main-tile">Custom Main Tile</label>

                <!-- MAIN TILE Search and SELECT -->
                <div class="create_sku_id_dropdown" id="skuIdMainTileDropDown">
                  <ng-select placement="top" [items]="customMainTileList" [placeholder]="searchByNamePlaceholderText"
                    bindLabel="name" bindValue="id" name="main-tile-list-dropDown" [clearable]="true"
                    [selectOnTab]="true" (change)='getSelectedMainTile($event)' [(ngModel)]="selectedMainTileId"
                    [ngModelOptions]="{standalone: true}">
                    <ng-template ng-option-tmp let-item="item" let-index="index" class="ng_selection_template">
                      <div id="skuItemName">{{item.name}}</div>
                      <span i18n="@@create-sku-id-info.sku-id-dropdown.content-id">Content ID: {{item.id}}</span>
                    </ng-template>
                  </ng-select>
                  <div *ngIf='!selectedMainTileId' class="search-icon"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="sku_detailed_sections2" id="skuDetailSection2">
            <div class="sku_subtitles" i18n="@@create-sku-id-info.title.select-promo-content" id="sku_SubTitles">Select
              Promotional content</div>
            <div class="d-flex pc-group" id="pcGrp1DFlex">
              <div class="form-group" id="pcGroupFrmGrp">
                <label for="promocontentg1" i18n="@@create-sku-id-info.label.promo-content1">Promotional Content Group
                  1</label>
                <!-- PROMO 1 Search and SELECT -->
                <div class="create_sku_id_dropdown" id="skuIdPromo1DropDown">
                  <ng-select placement="top" [items]="promoContentList" [placeholder]="searchByNamePlaceholderText"
                    bindLabel="name" bindValue="id" name="promo1-list-dropDown" [clearable]="true" [selectOnTab]="true"
                    (change)='getSelectedPromo($event, "promo1")' [(ngModel)]="selectedPromoId1"
                    [ngModelOptions]="{standalone: true}">
                    <ng-template ng-option-tmp let-item="item" let-index="index" class="ng_selection_template">
                      <div id="skuIdItemName">{{item.name}}</div>
                      <span i18n="@@create-sku-id-info.sku-id-dropdown.content-id">Content ID: {{item.id}}</span>
                    </ng-template>
                  </ng-select>
                  <div *ngIf='!selectedPromoId1' class="search-icon" id="searchIconPromoId1"></div>
                </div>
              </div>
              <div class="form-group" id="pcContentGrp2">
                <label for="promocontentg2" i18n="@@create-sku-id-info.label.promo-content2">Promotional Content Group
                  2</label>
                <!-- PROMO 2 Search and SELECT -->
                <div class="create_sku_id_dropdown" id="skuIdPromo2Dropdown">
                  <ng-select placement="top" [items]="promoContentList" [placeholder]="searchByNamePlaceholderText"
                    bindLabel="name" bindValue="id" name="promo2-list-dropDown" [clearable]="true" [selectOnTab]="true"
                    (change)='getSelectedPromo($event, "promo2")' [(ngModel)]="selectedPromoId2"
                    [ngModelOptions]="{standalone: true}">
                    <ng-template ng-option-tmp let-item="item" let-index="index" class="ng_selection_template">
                      <div>{{item.name}}</div>
                      <span i18n="@@create-sku-id-info.sku-id-dropdown.content-id">Content ID: {{item.id}}</span>
                    </ng-template>
                  </ng-select>
                  <div *ngIf='!selectedPromoId2' class="search-icon" id="searchIconPromoId2"></div>
                </div>
              </div>
              <div class="form-group" id="pcContentGrp3">
                <label for="promocontentg3" i18n="@@create-sku-id-info.label.promo-content3">Promotional Content Group
                  3</label>
                <!-- PROMO 3 Search and SELECT -->
                <div class="create_sku_id_dropdown" id="skuIDPromo3Dropdown">
                  <ng-select placement="top" [items]="promoContentList" [placeholder]="searchByNamePlaceholderText"
                    bindLabel="name" bindValue="id" name="promo2-list-dropDown" [clearable]="true" [selectOnTab]="true"
                    (change)='getSelectedPromo($event, "promo3")' [(ngModel)]="selectedPromoId3"
                    [ngModelOptions]="{standalone: true}">
                    <ng-template ng-option-tmp let-item="item" let-index="index" class="ng_selection_template">
                      <div>{{item.name}}</div>
                      <span i18n="@@create-sku-id-info.sku-id-dropdown.content-id">Content ID: {{item.id}}</span>
                    </ng-template>
                  </ng-select>
                  <div *ngIf='!selectedPromoId3' class="search-icon" id="searchIconPromo3"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="sku_detailed_sections" *ngIf="isRepairabilityIndexEnabled" id="skuDetailedSections">
            <div class="sku_subtitles" id="skuRepairailityIndex" i18n="@@create-sku-id-info.title.reparability-index">Repairability Index</div>
            <div class="form-group" id="repairabilityIndex">
              <input id="repairabilityindex" class="form-control" type="text" formControlName="repairabilityIndexVal"
                [placeholder]="enterValuePlaceholderText" (keypress)="getRepairabilityIndex($event)" maxlength="3" />
            </div>
          </div>
          <div class="pt-1 sku_detailed_sections2" *ngIf="isRepairabilityIndexEnabled" id="skuDetailedSection2">
            <div class="sku_subtitles" id="skuSubtitleDAS" i18n="@@create-sku-id-info.title.das">DAS</div>
            <div class="d-flex pc-group" id="dasTeleLabelPcGrp">
              <div class="form-group" id="dasTeteLabelFrmGrp">
                <label>{{dasTeteLabel}}</label>
                <input type="text" class="form-control" formControlName="dasTeteValue"
                  [placeholder]="enterValuePlaceholderText" (keypress)="getDASValue($event)"
                  (input)="$event.target.value = validateDASFormat($event.target.value,$event.target.id)">
              </div>
              <div class="form-group" id="dasTroncValueFrmGrp">
                <label>{{dasTroncLabel}}</label>
                <input type="text" class="form-control" formControlName="dasTroncValue"
                  [placeholder]="enterValuePlaceholderText" (keypress)="getDASValue($event)"
                  (input)="$event.target.value = validateDASFormat($event.target.value,$event.target.id)">
              </div>
              <div class="form-group" id="dasMembreValueFrmGrp">
                <label>{{dasMembreLabel}}</label>
                <input type="text" class="form-control" formControlName="dasMembreValue"
                  [placeholder]="enterValuePlaceholderText" (keypress)="getDASValue($event)"
                  (input)="$event.target.value = validateDASFormat($event.target.value,$event.target.id)">
              </div>
            </div>
          </div>
        </div>
        <div class="main_section_headers" id="mainSKUCompareSec">
          <div class="d-flex">
            <img class="sku_compare_icon" alt="SKU Compare icon"><span
              i18n="@@create-sku-id-info.title.compare-feature-info">COMPARE FEATURE INFORMATION (OPTIONAL)</span>
          </div>
          <div class="d-flex">
            <div id="collapseBtn" class="collapse_link collapsed collapse-button mr-2" type="button"
              (click)="getDetailsComparisonInfo()" [ngClass]="isCompareSectionExpanded ? 'transform-180' : ''">
              <svg class="accordian_expanded" width="24" height="24" viewBox="0 0 24 24" fill="currentColor"
                xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M2.469 6.96936C2.53867 6.89952 2.62143 6.8441 2.71255 6.80629C2.80367 6.76849 2.90135 6.74902 3 6.74902C3.09865 6.74902 3.19633 6.76849 3.28745 6.80629C3.37857 6.8441 3.46133 6.89952 3.531 6.96936L12 15.4399L20.469 6.96936C20.5387 6.89963 20.6215 6.84432 20.7126 6.80658C20.8037 6.76884 20.9014 6.74942 21 6.74942C21.0986 6.74942 21.1963 6.76884 21.2874 6.80658C21.3785 6.84432 21.4613 6.89963 21.531 6.96936C21.6007 7.0391 21.656 7.12188 21.6938 7.21299C21.7315 7.3041 21.7509 7.40175 21.7509 7.50036C21.7509 7.59898 21.7315 7.69663 21.6938 7.78774C21.656 7.87885 21.6007 7.96163 21.531 8.03136L12.531 17.0314C12.4613 17.1012 12.3786 17.1566 12.2874 17.1944C12.1963 17.2322 12.0986 17.2517 12 17.2517C11.9013 17.2517 11.8037 17.2322 11.7125 17.1944C11.6214 17.1566 11.5387 17.1012 11.469 17.0314L2.469 8.03136C2.39915 7.9617 2.34374 7.87893 2.30593 7.78781C2.26812 7.6967 2.24866 7.59901 2.24866 7.50036C2.24866 7.40171 2.26812 7.30403 2.30593 7.21291C2.34374 7.1218 2.39915 7.03903 2.469 6.96936Z" />
              </svg>
            </div>
          </div>
        </div>
        <div class="collapse sku-compare-sec-div" #collapse="ngbCollapse" [(ngbCollapse)]="!isCompareSectionExpanded"
          aria-labelledby="skuCompareSection" data-parent="#mainSKUCompareSec">
          <div class="sku_body_section2" id="skuCompareSectionDiv">
            <div class="sku_subsec1" id="skuSubSec1">
              <div class="important_note" i18n="@@create-sku-id-info.desc.compare-feature-note"
                id="importantNoteSkuDesc"><strong>Note</strong>: Comparison works only when device name is entered.
                Without the device name comparison would be suppressed.</div>
              <div class="form-group" id="deviceNameLabelFrmGrp">
                <label>{{deviceNameLabel}}</label>
                <input type="text" class="form-control" formControlName="deviceName" [placeholder]="deviceNameLabel">
              </div>
              <label class="pt-2" i18n="@@create-sku-id-info.title.device-image">Device Image</label>
              <div class="form-group" id="uploadHeroTile">
                <div class="upload-img-btn" id="uploadImgBtn">
                  <label>
                    <input #imageFile id="uploadHeroTile" type="file"
                      accept="image/jpg,image/jfif,image/x-png,image/jpeg,image/gif" (change)="uploadImage(imageFile)"
                      hidden>
                    <span class="btn btn-primary btn-sm">
                      <img class="sku_upload_icon" alt="upload image" />
                      <span i18n="@@upload-image.button.upload-image">Upload Image</span>
                    </span>
                  </label>
                  <ng-template #popContent>
                    <div>
                      <span class="pop-over-main">{{uploadImageTootliptext}}</span>
                      <ul class="pop-over-ul mt-4">
                        <li i18n="@@global.tooltip.image-rule-format">Images must be in <strong>JPG, PNG, JPEG,
                            JFIF</strong> or
                          <strong>GIF</strong> format</li>
                        <li *ngIf="!isRemoveEnabled"><span i18n="@@global.tooltip.image-max-size-error">Allowed maximum
                            size is
                            <strong>5 MB</strong></span></li>
                        <li><span i18n="@@global.tooltip.recommended-aspect-ratio">Recommended aspect ratio 4:3</span></li>
                        <img class="sku-recommended-ratio" alt="aspect-ratio">
                      </ul>
                    </div>
                  </ng-template>
                  <img class="info_icon" src="assets/images/info_circle_icon.svg" alt="hover for help" placement="right"
                    [ngbPopover]="popContent" triggers="mouseenter:mouseleave" />
                </div>
                <div class="uploaded-file-name" *ngIf="!imgTypeError && !imgSizeError" id="imgFileName">{{imgFileName}}
                </div>
                <div id="deviceImageTypeError" *ngIf="imgTypeError" class="uploadfile_err_msg error-msg-width">
                  <span i18n="@@global.content-grp.image-rule-format">Incorrect file type received. Image must be in
                    <strong>JPG, PNG</strong> or <strong>GIF</strong> format.</span>
                </div>
                <div id="deviceImageSizeError" *ngIf="imgSizeError && isImgFormat" class="uploadfile_err_msg">
                  <span i18n="@@global.content-grp.image-max-size-error">File exceeds maximum size <strong>(5
                      MB).</strong></span>
                </div>
              </div>
            </div>
          </div>
          <div class="sku_subsec2" id="skuSubSec2">
            <div class="mb-4 subheaders" i18n="@@create-sku-id-info.title.processor-details" id="processorDetails">Processor Details</div>
            <div class="important_note" i18n="@@create-sku-id-info.desc.processor-details-note" id="noteProcessor">
              <strong>Note</strong>: Comparison works only for devices with Intel® processors. If processor is not
              selected, comparison will be suppressed.</div>
            <div class="form-group proc-list-div" id="procListDiv">
              <label i18n="@@create-sku-id-info.label.select-processor">Select Processor</label>
              <div class="drop-search" id="dropSearch">
                <ng-select [items]="processorList" placeholder="{{processorListText}}" bindLabel="name"
                  name="processorname" [clearable]="true" [(ngModel)]="processorItem"
                  [ngModelOptions]="{standalone: true}" [selectOnTab]="true" (change)="onProcessorSelection($event)">
                </ng-select>
                <div *ngIf="!processorItem" class="search-icon" id="searchIconProcessItem"></div>
              </div>
            </div>
          </div>
          <div class="pt-2 sku_subsec2" id="memoryLabelDiv">
            <div class="mb-4 subheaders" id="skuMemoryLabel">{{memoryLabel}}</div>
            <div class="form-group" id="memoryValueFrmGrp">
              <label i18n="@@create-sku-id-info.label.ram">RAM</label>
              <input type="text" class="form-control" formControlName="memoryValue" [placeholder]="ramPlaceholderText">
            </div>
          </div>
          <div class="pt-2 sku_subsec2" id="operatingSystemValue">
            <div class="mb-4 subheaders" i18n="@@profile.table.os" id="profileOperatingSystem">Operating System</div>
            <div class="form-group os-list-div" id="operatingSystemFrmGrp">
              <label i18n="@@profile.table.os">Operating system</label>
              <div class="drop-search" id="dropOSSearch">
                <ng-select [items]="osList" [placeholder]="selectOperatingSystem" bindLabel="name" name="osname"
                  [clearable]="true" [(ngModel)]="osItem" [ngModelOptions]="{standalone: true}" [selectOnTab]="true"
                  (change)="onOsSelection($event)">
                </ng-select>
                <div *ngIf="!osItem" class="search-icon" id="searchIconOSItem"></div>
              </div>
            </div>
          </div>
          <div class="pt-2 sku_subsec2" id="skuInfoGaphics">
            <div class="mb-4 subheaders" i18n="@@create-sku-id-info.title.graphics" id="skuTitleGraphic">Graphics</div>
            <div class="form-group graphics-list-div" id="graphicsCardFrmGrp">
              <label i18n="@@create-sku-id-info.label.graphics-card">Graphics Card</label>
              <div class="drop-search" id="dropGraphcsSearch">
                <ng-select class="drop-container" [items]="graphicsModelList" [placeholder]="selectGraphicsModels" bindLabel="name"
                  name="graphicsname" [clearable]="true" [(ngModel)]="graphicsItem" [ngModelOptions]="{standalone: true}" [selectOnTab]="true" 
                  (change)="onGraphicsSelection($event)">
                </ng-select>
                <div *ngIf="!graphicsItem" class="search-icon rght" id="searchIconGraphicsItem"></div>
              </div>
            </div>
          </div>
          <div class="pt-2 sku_subsec2" id="storageValueTxt">
            <div class="mb-4 subheaders" id="storageLbl">{{storageLabel}}</div>
            <div class="form-group float-width" id="storageLblFrmGrp">
              <label>{{storageLabel}}</label>
              <input type="text" class="form-control" formControlName="storageValue"
                [placeholder]="storagePlaceholderText">
            </div>
          </div>
          <div class="pt-2 sku_subsec2" id="createSkuCustomFields">
            <div class="mb-4 subheaders" i18n="@@create-sku-id-info.title.custom-fields" id="skuInfoCustomFields">Custom
              fields</div>
            <div class="d-flex" *ngIf="isCusFieldLabelsVisible" id="isCustomFiledLabelVisible">
              <div class="form-group mb-0" id="usrRetailHQDwnldName">
                <label i18n="@@users-retailhq.downloadcsv.name">Name</label>
              </div>
              <div class="form-group mb-0" id="createSkuIDInfoLblValue">
                <label i18n="@@create-sku-id-info.label.value">Value</label>
              </div>
            </div>
            <div class="d-flex" formArrayName="customFields"
              *ngFor="let item of skuIdInfoForm.get('customFields')['controls']; let i = index;" id="customFieldsSKU">
              <ng-container [formGroupName]="i">
                <div class="form-group" id="setNameCustomFieldInfo">
                  <input type="text" class="form-control name-input-style" formControlName="name"
                    (input)="setNameCustomFieldInfo(i, $event.target.value)" [placeholder]="enterNamePlaceholderText"
                    required>
                  <span
                    *ngIf="!this.skuIdInfoForm.get('customFields')['controls'][i].valid && this.skuIdInfoForm.get('customFields')['controls'][i].controls.name.errors?.required"
                    class="pt-1 text-danger" i18n="@@create-account.input.required-field-validation">This field is
                    required</span>
                  <span i18n="@@create-account.double-quotes-validation"
                    *ngIf="this.skuIdInfoForm.get('customFields')['controls'][i].valid && checkQuotes(this.skuIdInfoForm.get('customFields')['controls'][i].controls?.name?.value)"
                    class="pt-1 text-danger">Double quote(s) (") cannot be entered</span>
                </div>
                <div class="form-group new-dynamic-value" id="setValueCustomFieldInfo">
                  <input type="text" class="form-control" formControlName="value"
                    (input)="setValueCustomFieldInfo(i, $event.target.value)" [placeholder]="enterValuePlaceholderText">
                </div>
                <img class="mb-3 cross_icon" alt="cross icon" role="button" (click)="removeCustomFields(i)" />
              </ng-container>
            </div>

          </div>
          <div class="button_wrapper sku_page_custom_fields pt-0" *ngIf="!suppressAdd" id="skuPageCustomFields">
            <button type="button" class="btn btn-outline-primary btn-md" (click)="addCustomFields()">
              <img class="sku_blue_plus_icon" alt="Add custom fields">
              <span i18n="@@create-sku-id-info.btn-text.add-custom-fields">Add Custom Fields</span>
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="button_wrapper sku_page_footer" id="skuPageFooter">
    <button type="button" class="btn btn-outline-primary" (click)="cancelChanges()">{{cancelLabel}}</button>
    <button type="button" class="btn btn-primary btn-md gtmSkuCreate" (click)="onSaveChanges()"
      [disabled]="!skuIdInfoForm?.controls?.skuCode?.value.trim()">{{saveChangesLabel}}</button>
  </div>
</section>